<template>
  <div>
    <!-- 面包屑 -->
    <bread-crumb path='内容管理' subPath='Mailgun列表'></bread-crumb>
    <!-- 主体列表 -->
    <el-card>
      <el-row :gutter="20">
        <el-col :span="2">
          <el-button type="primary" @click="showAddDialog">添加Mailgun</el-button>
        </el-col>
      </el-row>
      <el-table :data="list" stripe border :cell-style="{ textAlign: 'center' }">
        <el-table-column prop="id" label="ID" align="center" width="50px"></el-table-column>
        <el-table-column label="名称" prop="title" align="center"></el-table-column>
        <el-table-column label="域名" prop="domain" align="center"></el-table-column>
        <el-table-column label="发件人" prop="send_user" align="center"></el-table-column>
        <el-table-column label="密钥" prop="api_key" align="center"></el-table-column>
        <el-table-column label="创建时间" align="center">
          <template slot-scope="scope">
            {{scope.row.create_time | dateTimeFormat}}
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center" width="290px">
          <template slot-scope="scope">
            <el-button type="primary" icon="el-icon-edit" size="mini" @click="showEditDialog(scope.row.id)">编辑</el-button>
            <el-button type="danger" icon="el-icon-delete" size="mini" @click="deleteRow(scope.row.id)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
       @size-change="handleSizeChange"
       @current-change="handleCurrentChange"
       :current-page="param.page"
       :page-sizes="[10, 20, 30, 40, 50]"
       :page-size="param.count"
       layout="total, sizes, prev, pager, next, jumper"
       :total="total">
     </el-pagination>
    </el-card>
    <mailgun-add :visible="addDialogAvaible"
      :id="currentId"
      @add="addMailgun"
      @update="updateMailgun"
      @closeDialog="closeAddDialog"></mailgun-add>
  </div>
</template>

<script>
import BreadCrumb from '../BreadCrumb.vue'
import MailgunAdd from './MailgunAdd.vue'
export default {
  name: 'mailgun_list',
  components: {
    'bread-crumb': BreadCrumb,
    'mailgun-add': MailgunAdd
  },
  created () {
    this.getList()
  },
  data () {
    return {
      currentId: 0,
      list: [],
      addDialogAvaible: false,
      total: 0,
      pageTotal: 1,
      param: {
        page: 1,
        count: 10
      }
    }
  },
  methods: {
    async getList () {
      const res = await this.$http.get('/admin/mailgun/list', this.param)
      if (res.code === 0) {
        this.list = res.data.list
        this.total = res.data.total
        this.pageTotal = res.data.total_page
      } else {
        this.$message.error(res.msg)
      }
    },
    async addMailgun (data) {
      const res = await this.$http.post('/admin/mailgun/add', data)
      if (res.code === 0) {
        this.closeAddDialog()
        this.getList()
      } else {
        this.$message.error(res.msg)
      }
    },
    async updateMailgun (id, data) {
      const res = await this.$http.post('/admin/mailgun/update/' + id, data)
      if (res.code === 0) {
        this.closeAddDialog()
        this.getList()
      } else {
        this.$message.error(res.msg)
      }
    },
    handleSizeChange (size) {
      this.param.count = size
      this.getList()
    },
    handleCurrentChange (page) {
      this.param.page = page
      this.getList()
    },
    showAddDialog () {
      this.addDialogAvaible = true
    },
    closeAddDialog () {
      this.addDialogAvaible = false
      this.currentId = 0
    },
    showEditDialog (id) {
      this.currentId = id
      this.showAddDialog()
    },
    deleteRow (id) {
      this.$confirm('是否真的要删除此记录?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        const res = await this.$http.post('/admin/mailgun/delete/' + id)
        if (res.code === 0) {
          this.$message.success('删除成功')
          this.getList()
        } else {
          this.$message.error(res.msg)
        }
      }).catch(() => {})
    }
  }
}
</script>

<style scoped>
</style>
